/*
 * from the hostname demo.roamtest.plus it will return "demo"
 * */
export function getSubdomainName() {
  return window.location.host.split('.')[0]
}
